import React from "react";
import { faqs } from "../data/landing";
export function FaqSection() {
  return <section className="section" id="faq" data-id="element-29" data-mp="1pk1uonp8dzec">
      <div className="shell faq-shell" data-id="element-30" data-mp="1pl38gzxmszzr">
        <div className="section-intro" data-id="element-31" data-mp="1bkilrsolik0z">
          <p className="eyebrow" data-id="element-32" data-mp="1blkav12g571p">KNOW EXACTLY WHAT YOU’RE GETTING</p>
          <h2 data-id="element-33" data-mp="1gjc01nbpif27">
            A few questions
            <br data-id="element-34" data-mp="1gketa1wi4tla" />
            <span data-id="element-35" data-mp="1gjvj57d3f9ht">before you get started.</span>
          </h2>
        </div>
        <div className="fit-note" data-id="element-36" data-mp="24ahfw2hnd7ci">
          <strong data-id="element-37" data-mp="24bk585zbn1qb">Built for people who run customer service training.</strong>
          <p data-id="element-38" data-mp="28a9o2e34pbhc">
            A practical fit for supervisors, team leaders and internal trainers who facilitate practice with phone, email
            and chat agents. This is a facilitator resource, not a video course or a set of slides.
          </p>
        </div>
        <div className="faq-list" data-id="element-39" data-mp="2n7sctgft3oos">
          {faqs.map((faq, i) => <details key={faq.q} open={i === 0} data-id="element-40" data-mp="2rysawp0nwcsv" data-mpi={i}>
              <summary data-id="element-41" data-mp="2rzk6hzu9eaj5">
                {faq.q}
                <span aria-hidden="true" data-id="element-42" data-mp="14vabfwoqev1u">+</span>
              </summary>
              <p data-id="element-43" data-mp="14t7ltdrhr3xn">{faq.a}</p>
            </details>)}
        </div>
      </div>
    </section>;
}